import withSnackBar from '@app/components/core/message.component';
import CustomButton from '@app/components/shared/custom-button.component';
import SecretKeySettingComponent from '@app/components/shared/secret-key-setting.component';
import * as models from '@app/models';
import { Grid } from '@material-ui/core';
import React, { Component } from 'react';

class CredentialsInfoStepperComponent extends Component<
	models.ICredentialsInfoStepperComponentProps,
	models.ICredentialsInfoStepperComponentState
> {
	constructor(props: models.ICredentialsInfoStepperComponentProps) {
		super(props);
		this.state = {
			app: props.app,
		};
	}

	public render() {
		return (
			<>
				<SecretKeySettingComponent
					appDataToShow={this.state.app}
					accessToken={this.props.accessToken}
					onApiKeyRegenerated={(app: models.IAccountAppResponseVM) => this.setState({ app })}
				/>
				<Grid container={true} justifyContent='center' alignItems='center' className='pt-3'>
					<Grid item={true}>
						<CustomButton buttonText='Finish' onClick={() => this.props.updateStepper()} />
					</Grid>
				</Grid>
			</>
		);
	}
}

export default withSnackBar(CredentialsInfoStepperComponent);



// WEBPACK FOOTER //
// ./src/components/account/signup/quick/credentials-info-stepper.component.tsx